import React from "react";
import NumberData from "../../utils/EkadaData";
import { ColorArray } from "../../config/ColorArray";
import "./EkadaData.css";
import SectionDivider from "../../common/SectionDivider";

const EkadaData = () => {
    return (
          <>
        <SectionDivider title="ગુજરાતી એકડા" />
        <div className="ekada-grid">

            {NumberData.map((item, index) => {
                const color = ColorArray[index % ColorArray.length]?.color2;

                return (
                    <div className="ekada-card" key={index}>

                        {/* LEFT BIG NUMBER */}
                        <div className="ekada-number" style={{ color }}>
                            {item.gujarati_number}
                        </div>

                        {/* RIGHT TEXT */}
                        <div className="ekada-text">
                            <h2 className="ekada-guj-title" style={{ color }}>
                                {item.gujarati_title}
                            </h2>

                            <p className="ekada-eng" style={{ color }}>
                                {item.english_title}
                            </p>

                            <p className="ekada-hindi" style={{ color }}>
                                {item.hindi_title}
                            </p>

                        </div>

                    </div>
                );
            })}

        </div>
        </>
    );
};

export default EkadaData;
